import styled, { createGlobalStyle } from 'styled-components';
import '@fontsource/sora';
import '@fontsource/akaya-telivigala';

const GlobalStyles = createGlobalStyle`
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.5) transparent;
}
*::-webkit-scrollbar {
  width: 0.5px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
*::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.5);
  border-radius: 20px;
  border: transparent;
}

body {
  font-family: 'Sora', sans-serif;
  overflow-x: hidden;
}

a {
  color: inherit;
  text-decoration: none;
}
`;


export const Container = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-top: 100px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 50px;
  padding-left: 50px;
  @media screen and (max-width: 991px) {
    padding-right: 30px;
    padding-left: 30px;
  }
`;

export const Button = styled.button`
  border-radius: 4px;
  background: red;
  white-space: nowrap;
  padding: ${({ big }) => (big ? '12px 64px' : '10px 20px')};
  margin-right: 10px;
  color: #fff;
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  outline: none;
  border: none;
  cursor: pointer;
  &:hover {
    transition: all 0.3s ease-out;
    filter: brightness(0.70)

  }
  @media screen and (max-width: 960px) {
  }
`;

export const ButtonBorder = styled.button`
  border-radius: 15px;
  background: transparent;
  border: 2px solid #DC143C;
  white-space: nowrap;
  padding: ${({ big }) => (big ? '12px 64px' : '10px 20px')};
  margin-right: 10px;
  color: #fff;
  font-size: ${({ fontBig }) => (fontBig ? '25px' : '20px')};
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-out;
  &:hover {
    transform: scale(1.1);
  }
  @media screen and (max-width: 960px) {
  }
`;


export default  GlobalStyles;